module.exports = __webpack_public_path__ + "img/brand10.2852473f.png";